<template>  
    <div v-if="pending">
        <div class="d-flex justify-content-center loading-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
	<div v-else class="container py-5">
        <h2>{{ $t('activityCreate') }}</h2>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <RouterLink to="/modelings">
                        {{ $t('home') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">
                    <RouterLink :to="{ name: 'modeling', params: { id: this.$route.params.id } }">
                        {{ modelingName || $t('modelings') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">
                    <RouterLink :to="'/modeling/'+ this.$route.params.id + '/assettype/' + this.$route.params.assetTypeId" >
                        {{ assetTypeName || $t('assetType') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">{{ $t('activityCreate') }}</li>
            </ol>
        </nav>
        <div class="row">
            <div class="mb-3 col-md-4">
                <label class="form-label" for="name" required>{{ $t('name') }}</label>
                <input v-model="data.name" type="text" class="form-control" id="name" >
            </div>
              <div class="mb-3 col-md-8">
                <label class="form-label" for="description" required>{{ $t('description') }}</label>
                <input v-model="data.description" type="text" class="form-control" id="description">
            </div>
        </div>
        <div class="row mb-3">
            <div class="mb-3 col-md-4">
                <label class="form-label" for="unit" required>{{ $t('unit') }}</label>
                <input v-model="data.unit" type="text" class="form-control" id="unit" >
            </div>
            <div class="mb-3 col-md-3">
                <label class="form-label" for="unitCost" required>{{ $t('unitCost') }}</label>
                <input v-model="data.unitCost" type="number" class="form-control" id="unitCost">
            </div>
            <div class="mb-3 col-md-2">
                <label class="form-label" for="activityColor" required>{{ $t('activityColor') }}</label>
                <input v-model="data.activityColor" type="color" class="form-control" id="activityColor">
            </div>
        </div>
        <label class="form-label" for="costFactor" required>{{ $t('costFactor') }}</label>
        <div class="row">
            <div class="mb-3 col-md-3" v-for="(costFactor, i) in costFactors" :key="i">
                <div class="input-group mb-3">
                    <select :id="'changeToLifecycleId_' + i" class="form-select" v-model="costFactors[i]" >
                        <option disabled>{{ $t('select') }}</option>
                        <template v-if="datasetHeaders.length > 0" >
                            <option v-for="(datasetHeader, i) in datasetHeaders" :key="i" v-bind:value="datasetHeader.name">{{ datasetHeader.alias }}</option>
                        </template>
                    </select>
                    <span class="input-group-text" id="basic-addon2"><i class=" fa fa-remove" @click="removeCostFactor(i)" /></span>
                </div>
            </div>
            <div class="mb-3 col-md-3">
                <button class="form-control btn btn-light" id="unit" @click="addCostFactor" >{{$t('addCostFactor')}}</button>
            </div>
        </div>
        <div class="row mb-3">
            <div class="mb-3 col-md-6">
                <label class="form-check-label" for="rootActivity">
                    {{ $t('rootActivity') }}
                </label>
                <div class="input-group">
                    <div class="input-group-text">
                        <input class="form-check-input mt-0" v-model="data.rootActivity" type="checkbox" id="rootActivity">
                    </div>
                    <input v-bind:disabled="!data.rootActivity" v-model="data.rootActivityEffect" type="number" class="form-control" id="rootActivityEffect">
                    <select v-bind:disabled="!data.rootActivity" class="form-select" v-model="data.rootActivityEffectType" >
                        <option value="0">{{ $t('Absolute') }}</option>
                        <option value="1">{{ $t('Relative') }}</option>
                        <option value="2">{{ $t('Differential') }}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="d-grid gap-2 d-md-flex ">
            <button type="button" class="btn btn-primary" @click="onSubmit">{{ $t('create') }}</button>
            <button type="button" class="btn btn-secondary" @click="$router.push({ path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}` })">{{ $t('back') }}</button>
        </div>
    </div>
</template>

<script>
import ActivityApi from "../../api/server/activity";
import DatasetApi from "../../api/server/dataset";
import AssetTypeApi from "../../api/server/assetType";
import ModelingApi from "../../api/server/modeling";

export default {
    name: "activityCreate",
    watch: {
        $route: "requestData",
    },
    mounted() {
        this.requestData();
    },
    methods: {
        async requestData() {
            this.pending = true;

            var assetType = await AssetTypeApi.assetTypeDetail(this.$route.params.id, this.$route.params.assetTypeId);
            this.assetTypeName = assetType.name;

            var dataset = await DatasetApi.datasetDetail(this.$route.params.id, assetType.datasetId);
            var datasetContent = JSON.parse(dataset.content);
            this.datasetHeaders = datasetContent["headers"];

            var modeling = await ModelingApi.modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;

            this.pending = false;
        },
        async onSubmit() {
            if(this.data.name.length > 0) {
                if(this.costFactors.length > 1)
                    this.data.costFactor = this.costFactors.join(";");
                else 
                    this.data.costFactor = this.costFactors.join("");
                
                this.data.assetTypeId = this.$route.params.assetTypeId;
                await ActivityApi.activityCreate(this.$route.params.id, this.data);
                this.$router.go(-1);
            } else {
                this.showEmptyNameError();
            }
        },
        addCostFactor() {
            this.costFactors.push({ name: "" })
        },
        removeCostFactor(i) {
            this.costFactors.splice(i, 1);
        }
    },
    notifications: {
        showEmptyNameError: { 
            title: 'error',
            message: 'emptyName',
            type: 'error'
        }
    },
    data() {
        return {
            costFactors: [],
            datasetHeaders: [],
            data: {
                name: "",
                activityColor: "#004C83",
                rootActivity: false,
                rootActivityEffect: 0,
                rootActivityEffectType: 0,
                id: 0
            },
            modelingName: null,
            assetTypeName: null,
            pending: true
        }
    }
};
</script>